import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api/user";

class EnrollFormService {
  sendStudentData(data) {
    const instance = axios.create({
      headers: authHeader(),
      responseType: "arraybuffer",
    });

    return instance
      .post(API_URL + "/update/" + data.userId, data.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new EnrollFormService();
